import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip, Icon, USER_INTERFACE_SHARE } from '@bwoty-web/styleguide';
import './shareButton.scss';

const ShareButton = ({ labels }) => {
  const [tooltipText, setTooltipText] = useState(labels.shareText);
  const [showTooltip, setShowTooltip] = useState(false);
 
  const closeTooltip = () => {
    setShowTooltip(false);
    setTooltipText(labels.shareText)
  }
  
  const handleShare = () => {
    if (showTooltip) return;
    
    try {
      navigator.clipboard.writeText(window.location.href);
    } catch (err) {
      setTooltipText(labels.shareTextFail)
    }
    setShowTooltip(true);

    setTimeout(() => {
      closeTooltip()
    }, 4500)
  }

  return (
    <div className='vf-result-share'>
      <div
        className='vf-result-share__container'
        type='button'
        role='button'
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.keycode === 13) {
            handleShare()
          }
        }}
        onClick={handleShare}
      >
        <span className='vf-result-share__label'>
          {labels.shareLabel}
        </span>
        <Icon
          fill='#adadad'
          className='vf-result-share__icon'
          path={USER_INTERFACE_SHARE}
          role="button"
          size="s"
          />
      </div>

      { showTooltip && (
        <Tooltip
          arrowHorizontalPosition="right"
          className="vf-result-share__tooltip"
          onClose={() => closeTooltip()}
        >
          <span>{tooltipText}</span>
        </Tooltip>
      )}

    </div>
  )
}

ShareButton.propTypes = {
  labels: PropTypes.shape({
    shareLabel: PropTypes.string,
    shareText: PropTypes.string,
    shareTextFail: PropTypes.string,
  }).isRequired,
}

const mapStateToProps = ({ attributeCollection }) => {
  const labels = {
    shareLabel: attributeCollection.shareLabel,
    shareText: attributeCollection.shareText,
    shareTextFail: attributeCollection.shareTextFail,
  }
  return {
    labels,
  };
};

export default connect(mapStateToProps)(ShareButton);
